import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (process.env.NODE_ENV === 'development') {
      console.log('Form submitted with data:', formData);
    }

    const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    if (!SERVICE_ID || !TEMPLATE_ID || !PUBLIC_KEY) {
      if (process.env.NODE_ENV === 'development') {
        console.error('EmailJS credentials not found in environment variables');
      }
      alert('EmailJS is not properly configured. Please check your .env file.');
      return;
    }

    try {
      await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        {
          from_name: formData.name,
          from_email: formData.email,
          phone: formData.phone,
          subject: formData.subject,
          message: formData.message,
          to_email: 'tksimpextrading@gmail.com'
        },
        PUBLIC_KEY
      );
      alert('Thank you for your message! We will get back to you soon.');
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Email send failed:', error);
      }
      alert(`Sorry, there was an error sending your message. Error: ${error.text || error.message}`);
    }

    // Option 2: Send to a backend API
    /*
    try {
      const response = await fetch('YOUR_BACKEND_API_URL/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        alert('Thank you for your message! We will get back to you soon.');
      } else {
        throw new Error('Failed to send message');
      }
    } catch (error) {
      console.error('Form submission failed:', error);
      alert('Sorry, there was an error sending your message. Please try again.');
    }
    */

    // For now, just show success message
    alert('Thank you for your message! We will get back to you soon.');

    // Clear form
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2 className="fade-in">Contact Us</h2>
        <div className="contact-content">
          <div className="contact-info fade-in fade-in-delay-1">
            <h3>Get In Touch</h3>
            <div className="contact-details">
              <div className="contact-item">
                <h4>📞 Phone</h4>
                <p>+65 8151 5199</p>
              </div>
              <div className="contact-item">
                <h4>📧 Email</h4>
                <p>tksimpextrading@gmail.com</p>
              </div>
              <div className="contact-item">
                <h4>📍 Address</h4>
                <p>41,CuffRoad, Singapore-209751</p>
              </div>
            </div>
          </div>
          <div className="contact-form fade-in fade-in-delay-2">
            <h3>Send us a Message</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="tel"
                  name="phone"
                  placeholder="Your Phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <textarea
                  name="message"
                  placeholder="Your Message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="5"
                  required
                ></textarea>
              </div>
              <button type="submit" className="submit-button">Send Message</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;